import script from "./videoPeriodical.vue?vue&type=script&setup=true&lang=js"
export * from "./videoPeriodical.vue?vue&type=script&setup=true&lang=js"

import "./videoPeriodical.vue?vue&type=style&index=0&id=70278178&lang=less&scoped=true"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70278178"]])

export default __exports__